import { render, staticRenderFns } from "./securityBook.vue?vue&type=template&id=894ae92e&scoped=true"
import script from "./securityBook.vue?vue&type=script&lang=js"
export * from "./securityBook.vue?vue&type=script&lang=js"
import style0 from "./securityBook.vue?vue&type=style&index=0&id=894ae92e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "894ae92e",
  null
  
)

export default component.exports